import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IconAndButtonCardComponent } from '@components/icon-and-button-card/icon-and-button-card.component';
import { environment } from '@environments/environment';
import { ConsultationRequestService } from '@services/consultation-request.service';

@Component({
  selector: 'app-std-consultation-request-completed',
  templateUrl: './std-consultation-request-completed.component.html',
  styleUrls: [
    '../consultation-request/consultation-request.component.scss',
    './std-consultation-request-completed.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  imports: [IconAndButtonCardComponent],
})
export class StdConsultationRequestCompletedComponent implements OnInit {
  private titleService = inject(Title);
  private consultationRequestService = inject(ConsultationRequestService);

  public ngOnInit(): void {
    this.titleService.setTitle(environment.titles.consultationRequest);
    this.consultationRequestService.clearLastConsultationRequestData();
  }
}
